import React from "react";
import Image from "next/image";
import { PRODUCT_DEFAULT_ICON } from "@/cdn-resources";

const ProductSkeleton = () => {
  return (
    <div className="w-full h-full bg-[#EEEEEE] flex justify-center items-center">
      <Image
        src={PRODUCT_DEFAULT_ICON}
        alt="product-default"
        width={213}
        height={180}
        className="w-3/4"
      />
    </div>
  );
};

export default ProductSkeleton;
